import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinBagian = createAsyncThunk(
    "bagian/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterBagian',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getBagian = createAsyncThunk(
    "bagian/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMasterBagian',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertBagian = createAsyncThunk(
    "bagian/insert",
    async ({namaBagian, bagianID, detailAccountID, lawanAccountID, lawanBebanAccountID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaBagian", namaBagian);
        formData.append("bagianID", bagianID);
        formData.append("detailAccountID", detailAccountID || "");
        formData.append("lawanAccountID", lawanAccountID || "");
        formData.append("lawanBebanAccountID", lawanBebanAccountID || "");
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertMasterBagian',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateBagian = createAsyncThunk(
    "bagian/update",
    async ({namaBagian, idBagian, status, detailAccountID, lawanAccountID, lawanBebanAccountID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaBagian", namaBagian);
        formData.append("bagianID", idBagian);
        formData.append("status", status);
        formData.append("detailAccountID", detailAccountID || "");
        formData.append("lawanAccountID", lawanAccountID || "");
        formData.append("lawanBebanAccountID", lawanBebanAccountID || "");
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateMasterBagian',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const bagianSlice = createSlice({
    name: "bagian",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinBagian.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinBagian.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinBagian.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getBagian.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getBagian.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getBagian.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertBagian.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertBagian.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertBagian.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateBagian.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateBagian.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateBagian.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const bagianSelector = (state) => state.bagian;
